import React from 'react';
import { Inbox, AlertCircle } from 'lucide-react';

export function EmptyState({ title = 'Nenhum registro encontrado', description = 'Comece adicionando um novo item.', icon: Icon = Inbox, action }) {
  return (
    <div className="text-center py-16 px-4">
      <div className="w-16 h-16 mx-auto rounded-full bg-slate-100 flex items-center justify-center text-slate-400 mb-4">
        <Icon className="w-7 h-7" />
      </div>
      <h3 className="text-base font-semibold text-slate-900">{title}</h3>
      <p className="text-sm text-slate-500 mt-1">{description}</p>
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}

export function LoadingState({ rows = 6 }) {
  return (
    <div className="space-y-2 p-4">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-12 bg-slate-100 rounded-lg animate-pulse" />
      ))}
    </div>
  );
}

export function ErrorState({ message = 'Algo deu errado.', onRetry }) {
  return (
    <div className="text-center py-12 px-4">
      <div className="w-14 h-14 mx-auto rounded-full bg-red-100 flex items-center justify-center text-red-500 mb-3">
        <AlertCircle className="w-6 h-6" />
      </div>
      <p className="text-sm text-slate-700">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="mt-3 text-sm text-blue-600 hover:underline">Tentar novamente</button>
      )}
    </div>
  );
}
